// eslint-disable-next-line no-shadow
enum InviteStatus {
  ACCEPTED = 'accepted',
  NOT_ACCEPTED = 'notAccepted'
}

export default InviteStatus
